import { Component, Input, input } from '@angular/core';
import { IProject } from '../../interfaces/models/project.model';
import { TagModule } from 'primeng/tag';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-project-card',
  standalone: true,
  imports: [TagModule, CommonModule, RouterModule
    , TranslateModule
  ],
  templateUrl: './project-card.component.html',
  styleUrl: './project-card.component.scss'
})
export class ProjectCardComponent {
  hoveredProjectId = 0
  @Input() project!: IProject;
  @Input() strategyId!: number;
  onMouseEnter(hoveredProjectId: number) {
    this.hoveredProjectId = hoveredProjectId;
  }
  onMouseLeave() {
    this.hoveredProjectId = 0;
  }

}
